"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ms_1 = __importDefault(require("ms"));

var abort_controller_1 = __importDefault(require("abort-controller"));

var cross_fetch_1 = __importDefault(require("cross-fetch"));

var timers_1 = require("timers");

var Helper_1 = require("./Helper");

var Fetcher = /*#__PURE__*/function () {
  function Fetcher() {
    var defaultJsonRequestTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '30s';
    var defaultFileDownloadRequestTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
    var defaultPostTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5m';

    _classCallCheck(this, Fetcher);

    this.defaultJsonRequestTimeout = defaultJsonRequestTimeout;
    this.defaultFileDownloadRequestTimeout = defaultFileDownloadRequestTimeout;
    this.defaultPostTimeout = defaultPostTimeout;
  }

  _createClass(Fetcher, [{
    key: "fetchJson",
    value: function () {
      var _fetchJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options) {
        var opts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = Helper_1.applyDefaults({
                  attempts: 1,
                  timeout: this.defaultJsonRequestTimeout,
                  waitTime: '0.5s'
                }, options);
                return _context.abrupt("return", this.fetchInternal(url, function (response) {
                  return response.json();
                }, opts));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchJson(_x, _x2) {
        return _fetchJson.apply(this, arguments);
      }

      return fetchJson;
    }()
  }, {
    key: "fetchBuffer",
    value: function () {
      var _fetchBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, options) {
        var opts;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                opts = Helper_1.applyDefaults({
                  attempts: 1,
                  timeout: this.defaultFileDownloadRequestTimeout,
                  waitTime: '1s'
                }, options);
                return _context2.abrupt("return", this.fetchInternal(url, function (response) {
                  return response.buffer();
                }, opts));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchBuffer(_x3, _x4) {
        return _fetchBuffer.apply(this, arguments);
      }

      return fetchBuffer;
    }()
  }, {
    key: "postForm",
    value: function () {
      var _postForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, body) {
        var headers,
            options,
            opts,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                headers = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                options = _args3.length > 3 ? _args3[3] : undefined;
                opts = Helper_1.applyDefaults({
                  attempts: 1,
                  timeout: this.defaultPostTimeout,
                  waitTime: '1s'
                }, options);
                return _context3.abrupt("return", this.fetchInternal(url, function (response) {
                  return response.json();
                }, opts, 'POST', body, headers));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function postForm(_x5, _x6) {
        return _postForm.apply(this, arguments);
      }

      return postForm;
    }()
  }, {
    key: "fetchInternal",
    value: function () {
      var _fetchInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, responseConsumer, options) {
        var method,
            body,
            headers,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                method = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : 'GET';
                body = _args5.length > 4 ? _args5[4] : undefined;
                headers = _args5.length > 5 && _args5[5] !== undefined ? _args5[5] : {};
                return _context5.abrupt("return", Helper_1.retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  var controller, timeout, response, responseText;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          controller = new abort_controller_1.default();
                          timeout = timers_1.setTimeout(function () {
                            controller.abort();
                          }, ms_1.default(options.timeout));
                          _context4.prev = 2;
                          _context4.next = 5;
                          return cross_fetch_1.default(url, {
                            signal: controller.signal,
                            body: body,
                            method: method,
                            headers: headers
                          });

                        case 5:
                          response = _context4.sent;

                          if (!response.ok) {
                            _context4.next = 12;
                            break;
                          }

                          _context4.next = 9;
                          return responseConsumer(response);

                        case 9:
                          return _context4.abrupt("return", _context4.sent);

                        case 12:
                          _context4.next = 14;
                          return response.text();

                        case 14:
                          responseText = _context4.sent;
                          throw new Error("Failed to fetch ".concat(url, ". Got status ").concat(response.status, ". Response was '").concat(responseText, "'"));

                        case 16:
                          _context4.prev = 16;
                          timers_1.clearTimeout(timeout);
                          return _context4.finish(16);

                        case 19:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[2,, 16, 19]]);
                })), options.attempts, options.waitTime));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function fetchInternal(_x7, _x8, _x9) {
        return _fetchInternal.apply(this, arguments);
      }

      return fetchInternal;
    }()
  }, {
    key: "queryGraph",
    value: function () {
      var _queryGraph = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, query, variables, options) {
        var json;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.postForm(url, JSON.stringify({
                  query: query,
                  variables: variables
                }), {
                  'Content-Type': 'application/json'
                }, options);

              case 2:
                json = _context6.sent;

                if (!json.errors) {
                  _context6.next = 5;
                  break;
                }

                throw new Error("Error querying graph. Reasons: ".concat(JSON.stringify(json.errors)));

              case 5:
                return _context6.abrupt("return", json.data);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function queryGraph(_x10, _x11, _x12, _x13) {
        return _queryGraph.apply(this, arguments);
      }

      return queryGraph;
    }()
  }]);

  return Fetcher;
}();

exports.Fetcher = Fetcher;